export default "__VITE_ASSET__DP2RD6ef__"